import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import Login from "./pages/Login";
import Register from "./pages/Register";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/app/Dashboard";
import GastosFixos from "./pages/app/GastosFixos";
import GastosVariaveis from "./pages/app/GastosVariaveis";
import Entradas from "./pages/app/Entradas";
import Categorias from "./pages/app/Categorias";
import Cartoes from "./pages/app/Cartoes";
import Investimentos from "./pages/app/Investimentos";
import Objetivos from "./pages/app/Objetivos";
import DashboardAnual from "./pages/app/DashboardAnual";
import ListaDeCompras from "./pages/app/ListaDeCompras";
import Familia from "./pages/app/Familia";
import AceitarConvite from "./pages/AceitarConvite";
import AcessoBloqueado from "./pages/AcessoBloqueado";
import Admin from "./pages/Admin";
import TesteHeroRotativo from "./pages/TesteHeroRotativo";
import PoliticaPrivacidade from "./pages/PoliticaPrivacidade";
import { AppDataProvider } from "./pages/app/_shared/store";
import { AuthProvider, useAuth, isPlanActive } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import PaywallModal from "./components/PaywallModal";
import IOSInstallBanner from "./components/IOSInstallBanner";
import { Toaster } from "./components/ui/sonner";

const Protected = ({ children }) => (
  <ProtectedRoute requirePlan>
    <AppDataProvider>{children}</AppDataProvider>
  </ProtectedRoute>
);

function GlobalPaywall() {
  const { paywallOpen, setPaywallOpen } = useAuth();
  return <PaywallModal open={paywallOpen} onOpenChange={setPaywallOpen} />;
}

function AppRouter() {
  const location = useLocation();
  // Synchronously detect Google OAuth callback before any other route matches
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/auth-callback" element={<AuthCallback />} />
      <Route path="/app" element={<Protected><Dashboard /></Protected>} />
      <Route path="/app/gastos-fixos" element={<Protected><GastosFixos /></Protected>} />
      <Route path="/app/gastos-variaveis" element={<Protected><GastosVariaveis /></Protected>} />
      <Route path="/app/entradas" element={<Protected><Entradas /></Protected>} />
      <Route path="/app/categorias" element={<Protected><Categorias /></Protected>} />
      <Route path="/app/cartoes" element={<Protected><Cartoes /></Protected>} />
      <Route path="/app/investimentos" element={<Protected><Investimentos /></Protected>} />
      <Route path="/app/objetivos" element={<Protected><Objetivos /></Protected>} />
      <Route path="/app/dashboard-anual" element={<Protected><DashboardAnual /></Protected>} />
      <Route path="/app/lista-de-compras" element={<Protected><ListaDeCompras /></Protected>} />
      <Route path="/app/familia" element={<Protected><Familia /></Protected>} />
      <Route path="/aceitar-convite/:token" element={<AceitarConvite />} />
      <Route path="/acesso-bloqueado" element={<AcessoBloqueado />} />
      <Route path="/admin" element={<ProtectedRoute><Admin /></ProtectedRoute>} />
      <Route path="/teste-hero" element={<TesteHeroRotativo />} />
      <Route path="/privacidade" element={<PoliticaPrivacidade />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRouter />
          <GlobalPaywall />
        </AuthProvider>
      </BrowserRouter>
      <IOSInstallBanner />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
